import wrapper from 'redux-action-wrapper';
import assign from 'lodash/assign';

export default actions => dispatch => assign({dispatch}, wrapper(actions, dispatch));
